module.exports = __webpack_public_path__ + "static/img/apple1.9514a57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/help/apple1.png
// module id = 3oZD
// module chunks = 1